import axios from 'axios';

/**
 * Fetch events from Ticketmaster using lat/lng + local date range
 * @param {number} lat - Latitude of the search center
 * @param {number} lng - Longitude of the search center
 * @param {string} startDate - Format: YYYY-MM-DD
 * @param {string} endDate - Format: YYYY-MM-DD (next day)
 * @param {number} radius - Radius in km (default 50)
 */
export const fetchTicketmaster = async (lat, lng, startDate, endDate, radius, keyword) => {
  try {
    const localStartEnd = `${startDate}T00:00:00,${endDate}T00:00:00`;

    const response = await axios.get('https://app.ticketmaster.com/discovery/v2/events.json', {
      params: {
        latlong: `${lat},${lng}`,
        radius,
        unit: 'km',
        localStartEndDateTime: localStartEnd,
        sort: 'distance,asc',
        size: 100,
        ...(keyword ? { keyword } : {}),
        apikey: process.env.REACT_APP_TICKETMASTER_API_KEY,
      },
    });

    const events = response.data._embedded?.events || [];

    // Filter out resale events and those without a URL
    const filteredEvents = events.filter(event => {
      const outlets = event?.outlets || [];
      const hasUrl = !!event.url;
      const isResale = outlets.some(outlet => outlet?.type?.toLowerCase() === 'tmmarketplace');
      return !isResale && hasUrl;
    });

    return filteredEvents;
  } catch (error) {
    console.error('Error fetching events from Ticketmaster:', error.response?.data || error.message);
    return [];
  }
};
